export default __webpack_public_path__ + "static/media/quality_img-4.8262b7eb.jpg";